/**
 * Represents a single parking facility
 */
import { OccupationEditMode, OccupationType2 } from './occupation.interface';

export interface Facility {
  id: number;
  name: string;
  availableActions: FacilityAction[];
}

/**
 * Actions that can be performed on or with a facility.
 */
export interface FacilityAction {
  type: FacilityActionType;
  name: string;
}

/**
 * Result from API call to Adjust the number of occupants in a facility
 */
export interface FacilityActionResult {
  success: boolean;
  message: string;
}

export interface AdjustOccupationFacilityAction {
  type: FacilityActionType;
  occupationAdjustments: OccupationAdjustment[];
  reservationOccupationAdjustments: ReservationOccupationAdjustment[];
}

export interface SyncOccupationTotalFacilityAction {
  type: FacilityActionType;
  occupationAdjustments: OccupationAdjustment[];
  reservationOccupationAdjustments: ReservationOccupationAdjustment[];
}

export interface ActivateBypassAlarm {
  type: FacilityActionType.BypassAlarm;
  activate: boolean;
}

export type AdjustFacilityAction =
  | AdjustOccupationFacilityAction
  | SyncOccupationTotalFacilityAction
  | ActivateBypassAlarm;

export interface OccupationAdjustment {
  type: OccupationType2;
  editMode: OccupationEditMode;
  value: number;
}

export interface ReservationOccupationAdjustment {
  type: OccupationType2;
  value: number;
}

/**
 * API Action, number of occupants in a facility
 */
export enum FacilityActionType {
  AdjustOccupation = 0,
  SyncOccupationTotal = 1,
  BypassAlarm = 2,
}
